import { render, staticRenderFns } from "./search-header-nav-below.vue?vue&type=template&id=c0a28cd2&scoped=true&"
import script from "./search-header-nav-below.vue?vue&type=script&lang=js&"
export * from "./search-header-nav-below.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=c0a28cd2&scoped=true&lang=css&"
import style1 from "./search-header-nav-below.vue?vue&type=style&index=1&id=c0a28cd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a28cd2",
  null
  
)

export default component.exports